import {
    SliceFactory,
    FetchCollectionData,
    ApiCollectionResponse,
    FetchItemDataType,
} from '@europrocurement/l2d-redux-utils';
import {
    ConfigurationParameters as FormalityApiConfigurationParameters,
    Configuration,
    TypeDeDocumentApiApiTypesDocumentsGetCollectionRequest,
    TblTypeDocumentDocumentfileRead,
    TypeDeDocumentApi,
    TypeDeDocumentApiApiTypesDocumentsIdGetRequest,
} from '../../../openApi/ApiFormalite';
import { FORMALITE_DOCUMENT_SLICE_NAME, FORMALITES_REDUCER_NAME } from '../constants';

export type FormaliteDocumentApiObject = TblTypeDocumentDocumentfileRead & Record<string, unknown>;

export type FormaliteDocument = FormaliteDocumentApiObject;

export const mapperFormaliteDocument = function (document: FormaliteDocument) {
    return {
        ...document,
    } as FormaliteDocument;
};

export function createFormaliteDocumentSlice(configuration: FormalityApiConfigurationParameters) {
    const conf = new Configuration(configuration);
    const api = new TypeDeDocumentApi(conf);

    const fetchFormaliteDocumentsCollection: FetchCollectionData<FormaliteDocument> = ({
        pagination,
        filters,
    }) => {
        const options = undefined;
        const hasTypeFilter =
            typeof filters?.type !== 'undefined' && filters.type !== null && filters.type !== '';
        const hasLibelleFilter =
            typeof filters?.libelle !== 'undefined' &&
            filters.libelle !== null &&
            filters.libelle !== '';
        const hasNameFilter =
            typeof filters?.name !== 'undefined' && filters.name !== null && filters.name !== '';
        const requestParameters: TypeDeDocumentApiApiTypesDocumentsGetCollectionRequest = {
            page: pagination.page + 1,
            itemsPerPage: pagination.itemsPerPage ?? 500,
            ...(hasTypeFilter ? { type: Number(filters.type) } : {}),
            ...(hasLibelleFilter ? { libelle: String(filters.libelle) } : {}),
            ...(hasNameFilter ? { name: String(filters.name) } : {}),
        };

        return api
            .apiTypesDocumentsGetCollection(requestParameters, options)
            .then((res) => res.data) as Promise<ApiCollectionResponse<FormaliteDocument>>;
    };

    const fetchFormaliteDocumentItem: FetchItemDataType<FormaliteDocument> = ({ idItem }) => {
        const requestParameters: TypeDeDocumentApiApiTypesDocumentsIdGetRequest = {
            id: String(idItem),
        };

        return api
            .apiTypesDocumentsIdGet(requestParameters)
            .then((res) => res.data) as Promise<FormaliteDocument>;
    };

    const { slice: formaliteDocumentSlice, dataSourcesThunks: formaliteDocumentDataSourcesThunks } =
        SliceFactory.createSlice<FormaliteDocument, FormaliteDocument>(
            FORMALITE_DOCUMENT_SLICE_NAME,
            FORMALITES_REDUCER_NAME,
            [],
            fetchFormaliteDocumentsCollection,
            fetchFormaliteDocumentItem,
            mapperFormaliteDocument,
            {},
        );

    return { formaliteDocumentSlice, formaliteDocumentDataSourcesThunks };
}
